import React, { ComponentType } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useRootSelector } from '../../../../../../store/hooks';
import { DAY_MONTH, MONTH_DAY } from '../../../../../../constants';
import { selectSiteHeaderData } from '../../../../../../store/features/siteHeader';
import { getCorrectLocale } from '../../../../../../helpers';
import { ParagraphProps } from '../../styledComponents';

export type StartDateProps = {
  value: string;
  as: ComponentType<ParagraphProps>;
};

export function StartDate({ value, as: Component }: StartDateProps) {
  const { i18n } = useTranslation();
  const { dateFormat = DAY_MONTH } = useRootSelector(selectSiteHeaderData);

  const momentLocale = getCorrectLocale(i18n.language);
  const startDate = moment(value, ['YYYY-MM-DD'])
    .locale(momentLocale)
    .format(dateFormat === MONTH_DAY ? 'MMM DD, YYYY' : 'DD MMM YYYY');

  return <Component text={startDate} />;
}
